import { classes } from './Skeleton.st.css';

export const { skeleton, placeholder } = classes;
